AOS.init({
    disable: function () {
        var maxWidth = 800;
        return window.innerWidth < maxWidth;
    },
    startEvent: "DOMContentLoaded",
    initClassName: "aos-init",
    animatedClassName: "aos-animate",
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,
    offset: 100,
    delay: 200,
    duration: 1000,
    easing: "ease",
    once: false,
    mirror: false,
    anchorPlacement: "top-bottom",
});

class VideoResponser {
  constructor(selector) {
      const $video = document.querySelector(selector);
      this.options = { 
          selector, 
          breakpoints: { 
            default: { 
              src: $video.getAttribute('data-src'),
              poster: $video.getAttribute('poster'),
            } 
          } 
      };

      // get a list of video switching points and links to the videos themselves 
      $video.querySelectorAll('[data-src]').forEach(element => this.options.breakpoints[element.getAttribute('data-mw')] = { src: element.getAttribute('data-src'), poster: element.getAttribute('data-poster') });
      $video.innerHTML = ''; // we clean up so that there is nothing superfluous 
      // run the handler and track the change in screen width
      this.responseVideo(this.options);
      this.resizer();
  }

  /** Function runs on resize  */
  resizer() {
      window.addEventListener("resize", () => this.responseVideo(this.options));
  }

  /** 
   * Change src value of video link to fit screen width 
   * 
   * @param {Object} options object with options 
   */
  responseVideo(options) {
      const {selector, breakpoints} = options; // get options
      let $video = document.querySelector(selector);
      const widthNow = $video.getAttribute('data-width-now') || null;
      let maxBreakpoint = Math.max.apply(Math, Object.keys(breakpoints).filter(key => document.body.clientWidth <= key).map(Number));
      maxBreakpoint = "-Infinity" == maxBreakpoint ? 'default' : maxBreakpoint;
      const nowBreakpoint = maxBreakpoint || 'default'; // choose either the maximum value, if not, then the default 

      if(widthNow && widthNow == nowBreakpoint) return; // check if the video needs to be changed 

      $video.setAttribute('data-width-now', nowBreakpoint);
      $video.src = breakpoints[nowBreakpoint].src;
      $video.poster = breakpoints[nowBreakpoint].poster;
      setTimeout(() => {
        $video.style.display = 'block';
        $('.poster-video-bg').remove();
      }, 300);
  }
}



$(document).ready(function () {
    
    function isMobile() {
        var maxWidth = 800;
        return window.innerWidth < maxWidth;
    }

    $('.introduction-home-banner .arrow-down').on('click', function(e) {
        var promotionSticky = $(".header-banner");
        var windowHeight = $(window).height();
        var offsetHeader = (window.innerWidth >= 1200 && window.innerWidth <= 1600) ? (160 - 96) : (190 - 96);
        
        var offsetTopWithPromotion = windowHeight + offsetHeader;
        var offsetTopWithoutPromotion = windowHeight - 61;
        offsetTopWithPromotion = isMobile() ? (windowHeight - 60) : offsetTopWithPromotion
        var offsetTop = promotionSticky.hasClass('header-banner') ? offsetTopWithPromotion : offsetTopWithoutPromotion;

        $('html, body').animate({
            scrollTop: offsetTop
        }, 1000);
    });

    $('[data-toggle="tooltip"]').tooltip();
});